import React, { Component } from 'react'
import NotFoundComponent from '../../../components/NotFoundComponent'

class NotFound extends Component {
  constructor () {
    super()
    this.state = {
    }
  }

  render () {
    return (
      <NotFoundComponent />
    )
  }
}

export default NotFound



// WEBPACK FOOTER //
// ./src/routes/NotFound/components/notFound.js